import { render, staticRenderFns } from "./SignupPageSignUpRoute.vue?vue&type=template&id=a2e08538"
import script from "./SignupPageSignUpRoute.vue?vue&type=script&lang=js"
export * from "./SignupPageSignUpRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports